import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import BooksSection from './components/BooksSection';
import SistersSection from './components/SistersSection';
import StoriesSection from './components/StoriesSection';
import WhereToBuySection from './components/WhereToBuySection';
import KnowledgeBaseSection from './components/KnowledgeBaseSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import FreeGiftModal from './components/FreeGiftModal';

export default function Home() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="w-full min-h-screen">
      <Navbar onOpenModal={() => setShowModal(true)} />
      <main>
        <HeroSection onOpenModal={() => setShowModal(true)} />
        <BooksSection />
        <SistersSection />
        <StoriesSection onOpenModal={() => setShowModal(true)} />
        <WhereToBuySection />
        <CTASection onOpenModal={() => setShowModal(true)} />
        <KnowledgeBaseSection />
      </main>
      <Footer />
      <FreeGiftModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
}